<template>
    <img id="grain" src="/assets/grain.png"/>
    <section id="section-home">
        <BackgroundAssets data-aos="custom-fade-in"/>
        <div class="tt">
            <img src="/assets/tt.png" data-aos="custom-fade-in"/>
            <div class="caption">
                <p data-aos="custom-fade-in">based on true events </p>
                <p data-aos="custom-fade-in"> in theaters everywhere june 6th</p>
            </div>
        </div>
        <div class="capper">
            <div class="capper-padded">
                <div class="two-col">
                    <div class="coll">
                        <div class="articles">

                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-excorcist.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>Emma Schmidt & The Exorcist</h2>
                                        <p>Hear from director David Midell about how, after his deep-dive into researching the movie, he believes Emma Schmidt’s case was likely one of the prime inspirations for The Exorcist.</p>
                                        <div class="btn-outer">
                                            <div class="btn" @click="openVideo({ytid:'vZh4VT82kIw'})">
                                                <span>Hear from the Director</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>


                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-real.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>MEET THE REAL LIFE-AND-DEATH PLAYERS</h2>
                                        <p>Father Theophilus Riesinger and Father Joseph Steiger worked together to help drive the demons from the real-life Emma Schmidt. Examine historical photos of the real figures who performed—and survived—the exorcism.</p>
                                        <div class="btn-outer">
                                            <div class="btn" @click="openGallery({images:[
                                                {
                                                    img:'real-theo.jpg',
                                                    aspectRatio:640/850,
                                                    caption:'Father Theophilus Riesinger'
                                                },
                                                {
                                                    img:'real-joseph.jpg',
                                                    aspectRatio:206/245,
                                                    caption:'Reverend Joseph Steiger'
                                                },
                                                {
                                                    img:'real-anna.jpg',
                                                    aspectRatio:356/258,
                                                    caption:'Emma Schmidt'
                                                },
                                            ], seadragonEnabled: false})">
                                                <span>VIEW PHOTOS</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>





                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-begone.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>THE FULL TALE OF THIS SENSATIONAL EXPULSION OF THE DEVIL</h2>
                                        <p>“Some persons have asked the question: ‘Why publish a story of this kind in our age and civilization?’ One could answer this by replying that our age and civilization needs to learn anew a lesson that was vainly laughed to scorn in past generations.”</p>
                                        <div class="btn-outer">
                                            <a href="/begone-satan.pdf" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>





                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-news.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>“‘DEVIL’ DRIVEN FROM WOMAN SAYS REPORTS”</h2>
                                        <p>“Earling, September 22.—Unconfirmed reports late today say that the unknown woman being given the ritual of exorcism by two Catholic priests here has…”</p>
                                        <div class="btn-outer">
                                            <div class="btn" @click="openGallery({images:[
                                                {
                                                    img:'newspaper-3.jpg',
                                                    aspectRatio:2628/3895,
                                                    caption:'The Des Moines Register, September 23, 1928, Page 19'
                                                },
                                                {
                                                    img:'newspaper-2.jpg',
                                                    aspectRatio:3060/3993,
                                                    caption:'The Daily Nonpareil, September 24, 1928 Page 3'
                                                },
                                                {
                                                    img:'newspaper-1.jpg',
                                                    aspectRatio:2835/3611,
                                                    caption:'Lime Springs Herald, February 18, 1926, Page 5'
                                                },

                                            ], seadragonEnabled: true})">
                                                <span>VIEW ARTICLES</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>





                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-time.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>Religion: Exorcist & Energumen</h2>
                                        <p>In St. Anthony's Monastery of the Capuchin Friars at Marathon, Wis. last week, a wise and white-haired monk named Rev. Theophilus Riesinger went about his daily orisons and meditations, indifferent to the fact that he was being widely publicized among U.S. Catholics as a potent and mystic exorcist of demons. </p>
                                        <div class="btn-outer">
                                            <a href="https://time.com/vault/issue/1936-02-17/page/27/" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>


                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-anna.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>WIKIPEDIA: ANNA ECKLUND</h2>
                                        <p>Anna Ecklund was a pseudonym for Emma Schmidt (March 23, 1882 – July 23, 1941), an American woman whose alleged demonic possession and exorcism occurred over several decades, culminating in an extensive exorcism that lasted from August 18 to December 23, 1928, in Earling, Iowa.
                                        </p>
                                        <div class="btn-outer">
                                            <a href="https://en.wikipedia.org/wiki/Anna_Ecklund" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>


                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-theo.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>WIKIPEDIA: FATHER THEO</h2>
                                        <p>Riesinger was born in Germany. He later moved to the United States where he entered the Capuchin Order. He was ordained on 29 June 1899. In the summer of 1928, due to his previous experience in dealing with possessions, he was requested by the Bishop of Des Moines to conduct the rite of exorcism… </p>
                                        <div class="btn-outer">
                                            <a href="https://en.wikipedia.org/wiki/Theophilus_Riesinger" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>



                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-hushed.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>HUSHED UP HISTORY: THE EVIL AND EXORCISM OF EMMA SCHMIDT</h2>
                                        <p>The voices were haunting, as much as she wanted to she could not enter church, her thoughts were increasingly intrusive, and the nervousness was growing stronger. Now, she was in a Franciscan convent just outside of Earling, Iowa with her arms bound and a small team of nuns making sure she could not leave the iron bed she was resting on.</p>
                                        <div class="btn-outer">
                                            <a href="https://husheduphistory.com/post/619278048738607104/the-evil-and-exorcism-of-emma-schmidt" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>



                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-bts.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>HEAR FROM FATHER AARON TODAY</h2>
                                        <p>The Priest who entrusted his parish for filming of this “true event” movie shares his thoughts about exorcism with the cast and his—and the Church’s—thinking about what really happened nearly 100 years ago.</p>
                                        <div class="btn-outer">
                                            <div class="btn" @click="openVideo({ytid:'D_SN11XOrpI'})">
                                                <span>True Story Exorcism</span>
                                            </div>
                                            <div class="btn" @click="openVideo({ytid:'QsmPW03Nwds'})">
                                                <span>The Script</span>
                                            </div>
                                            <div class="btn" @click="openVideo({ytid:'hJS5A7D9GoI'})">
                                                <span>The Faith</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>




                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-inspiration.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>Demons in iowa: the possesion that inspired “the exorcist”</h2>
                                        <p>One of the most notorious claims of demon possession took place in Earling, Iowa. The victim who went by Anna Ecklund in reports underwent such intense trauma; both supernatural and not. Her story ended up influencing one of the most famous exorcisms in pop culture.</p>
                                        <div class="btn-outer">
                                            <a href="https://khak.com/demons-in-iowa-the-possession-that-inspired-the-exorcist/" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>



                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-still.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>EXCLUSIVE: OFFICIAL FILM STILLS</h2>
                                        <p>Be among the first to review official behind-the-scenes photography taken during filming of The Ritual, getting an early look at the portrayals of Al Pacino, Dan Stevens, Ashley Greene, and Abigail Cowen among others.</p>
                                        <div class="btn-outer">
                                            <div class="btn" @click="openGallery({images:[
                                                {
                                                    img:'still-1.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-2.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-3.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-4.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-5.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-6.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-7.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-8.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-9.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-10.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-11.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-12.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-13.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-14.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-15.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-16.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-17.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },{
                                                    img:'still-18.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                                {
                                                    img:'still-19.jpg',
                                                    aspectRatio:2000/999,
                                                    caption:''
                                                },
                                            ], seadragonEnabled: false})">
                                                <span>VIEW PHOTOS</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>







                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-faq.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>GET YOUR EXORCISM FAQ’s ANSWERED HERE</h2>
                                        <p>Answers are provided by specialists in The Latin Church Bishops of the United States Conference of Catholic Bishops and by experts in canon law. The Committee on Divine Worship has approved these questions and answers, in hopes that clear information is brought to bear on a topic that is often shrouded in mystery or misinformation.</p>
                                        <div class="btn-outer">
                                            <a href="https://www.usccb.org/prayer-and-worship/sacraments-and-sacramentals/sacramentals-blessings/exorcism" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>



                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-changing.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>THE CHURCH’S CHANGING VIEWS ON EXORCISM—AND WHY</h2>
                                        <p>In September 2021, a 3-year-old was killed during an exorcism in a small Pentecostal church in San Jose, California. The child’s throat was allegedly squeezed and her head held down during the ceremony, which likely asphyxiated her. In May 2022, three members of the victim’s family were charged with felony child abuse...</p>
                                        <div class="btn-outer">
                                            <a href="https://news.txst.edu/the-conversation/2022/catholic-churchs-view-on-exorcism-have-changed.html" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>





                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-request.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>HOW TO REQUEST AN EXORCISM OF YOUR OWN</h2>
                                        <p>The Rite of Exorcism is a sacramental of the Catholic Church whereby “the Church asks publicly and authoritatively in the name of Jesus Christ that a person or object be protected against the power of the Evil One and withdrawn from his dominion.” </p>
                                        <div class="btn-outer">
                                            <a href="https://adw.org/about-us/resources/request-an-exorcism/" target="_blank">
                                                <div class="btn">
                                                    <span>REQUEST TODAY</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>






                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-curious.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>DEMON-CURIOUS? 7 THINGS YOU HAVE TO KNOW ABOUT EXORCISMS</h2>
                                        <p>There are approximately 150 Catholic priests in the United States who practice exorcism, an ancient practice to rid people, places and objects of demonic influence . . . The Columbas Dispatch spoke about the practice with the Rev. Vincent Lampert, who performs hundreds of exorcisms a year.</p>
                                        <div class="btn-outer">
                                            <a href="https://www.dispatch.com/story/lifestyle/faith/2022/10/28/curious-about-demonic-possession-and-exorcism-7-things-to-know/69593131007/" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>



                            <article class="article" data-aos="custom-fade-in">
                                <div class="al">
                                    <img src="/assets/article-vatican.jpg" />
                                </div>
                                <div class="ar">
                                    <div class="ar2">
                                        <h2>THE VATICAN’S NEW RULES FOR EXORCISMS</h2>
                                        <p>It is 90 pages long, bound in leather, and written and printed entirely in Latin. Issued in 1999 by the Vatican, De Exorcismis et supplicationibus quibusdam is the Roman Catholic Church's new manual for those whose duties include driving out the Devil. It is the first primer to be issued to exorcists since 1614.</p>
                                        <div class="btn-outer">
                                            <a href="https://www.theguardian.com/world/1999/jan/27/religion.uk" target="_blank">
                                                <div class="btn">
                                                    <span>LEARN MORE</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>







                        </div>
                    </div>
                    <div class="colr" data-aos="custom-fade-in">
                        <a href="https://theritualmovie.com" target="_blank">
                            <img src="/assets/sidebar.jpg" data-aos="custom-fade-in"/>
                        </a>
                    </div>
                </div>

                <AllButtons></AllButtons>

            </div>
        </div>
        <div class="top-link" data-aos="custom-fade-in">
            <div class="capper">
                <div class="capper-padded">
                    <div class="btn-outer">
                        <a href="https://www.theritualmovie.com" target="_blank">
                            <div class="btn">
                                <span>GET TICKETS</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import gh from "@/helpers/gh"
import BackgroundAssets from '@/components/blocks/BackgroundAssets'
import AllButtons from '@/components/blocks/AllButtons'


export default {
    name: "HomePage",
    components: {
        BackgroundAssets,
        AllButtons
    },
    data() {
        return {
            gh: gh,
            window: window,
        }
    },
    mounted() {
        gh.globalSectionInit()
        this.resize();
        window.addEventListener('resize', this.resize);
        this.preloadImages();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.resize);
    },
    methods: {
        preloadImages() {
            const images = [
                '/assets/newspaper-3.jpg',
                '/assets/newspaper-2.jpg',
                '/assets/newspaper-1.jpg'
            ];
            images.forEach(src => {
                const img = new Image();
                img.src = src;
            });
        },
        resize() {

        },
        openVideo(obj) {
            this.gh.openOverlay('video', obj);
        },
        openGallery(obj) {
            this.gh.openOverlay('gallery', obj);
        },
    }
}
</script>